import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import ScrollToTop from "../../pages/ScrollToTopbutton";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <div>{children}</div>
      <Footer />
      <ScrollToTop/>
      <ToastContainer />

    </>
  );
};

export default Layout;
